import { useContext, useEffect, useRef } from "react";
import type { FC } from "react";
import { Bill } from "@common/types/bill";
import { PaginatedBillsTableContext } from "./PaginatedBillsTable.context";

interface BillAutoSelectorProps {
    initialIds: string[];
    onSelect: (bill: Bill) => void;
}

export const BillAutoSelector: FC<BillAutoSelectorProps> = ({
    initialIds,
    onSelect,
}) => {
    const { bills } = useContext(PaginatedBillsTableContext);
    const handledRef = useRef(false);

    useEffect(() => {
        if (handledRef.current || !bills?.length) {
            return;
        }
        const match = bills.find((b) => initialIds.includes(b.id));
        if (match) {
            handledRef.current = true;
            onSelect(match);
        }
    }, [bills, initialIds, onSelect]);

    return null;
};
